import { memo, SVGProps } from "react"

const MoneyChange = memo((props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M17 4H7C4 4 2 5.5 2 9v3.56c0 .37.38.6.71.45.98-.45 2.11-.62 3.3-.41 2.63.47 4.56 2.91 4.49 5.58-.01.42-.07.83-.18 1.23-.08.31.17.6.49.6H17c3 0 5-1.5 5-5V9c0-3.5-2-5-5-5Zm-5 10.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Zm7.25-.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4c0-.41.34-.75.75-.75s.75.34.75.75v4Z"
                fill="#fff"
            />
            <path
                d="M5 14c-1.25 0-2.38.59-3.11 1.49A3.96 3.96 0 0 0 1 18c0 2.21 1.8 4 4 4 1.74 0 3.23-1.11 3.77-2.67.15-.41.23-.86.23-1.33 0-2.2-1.79-4-4-4Zm2.36 5.74c-.02.06-.06.12-.1.16l-.72.71c-.09.1-.21.14-.34.14a.46.46 0 0 1-.35-.14.471.471 0 0 1-.08-.57H3.76c-.64 0-1.16-.52-1.16-1.17v-.1c0-.28.22-.49.49-.49s.49.21.49.49v.1c0 .11.08.2.19.2h2.01c-.1-.19-.08-.42.08-.58.19-.19.5-.19.68 0l.72.72c.04.04.08.1.11.16.04.11.04.25-.01.37Zm.04-2.51c0 .28-.22.49-.49.49s-.49-.21-.49-.49v-.1c0-.11-.08-.2-.19-.2h-2a.483.483 0 0 1-.43.72c-.12 0-.25-.05-.34-.14l-.72-.72a.645.645 0 0 1-.11-.16.585.585 0 0 1 0-.37c.03-.05.06-.12.11-.16l.72-.71c.19-.2.5-.2.68 0 .16.15.18.39.08.57h2.01c.64 0 1.16.52 1.16 1.17v.1h.01Z"
                fill="#fff"
            />
        </svg>
    )
})

export default MoneyChange
